import { HomeJobs } from "@/pages/home/components/HomeJobs.tsx";
import { HomeMyCompany } from "@/pages/home/components/HomeMyCompany.tsx";
import { HomeMyTeam } from "@/pages/home/components/HomeMyTeam.tsx";
import { HomeNews } from "@/pages/home/components/HomeNews.tsx";
import { HomeNotifications } from "@/pages/home/components/HomeNotifications.tsx";
import { HomeThingsToDo } from "@/pages/home/components/HomeThingsToDo.tsx";
import { HomeUpcomingBirthdays } from "@/pages/home/components/HomeUpcomingBirthdays.tsx";
import { HomeUpcomingEvents } from "@/pages/home/components/HomeUpcomingEvents.tsx";
import { ApiPermission, PermissionsKeys } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { ComponentType } from "react";

export type HomeWidgetId =
  | "things_to_do"
  | "notifications"
  | "my_company"
  | "news"
  | "jobs"
  | "upcoming_events"
  | "my_team"
  | "upcoming_birthdays";

export interface HomeWidgetContext {
  isFeatureEnabled: (feature: ApiFeatureType) => boolean;
  canIEdit: (key: PermissionsKeys) => boolean;
}

export interface HomeWidgetConfig {
  component: ComponentType;
  titleKey: string;
  isAvailable: (ctx: HomeWidgetContext) => boolean;
}

export const homeWidgetRegistry: Record<HomeWidgetId, HomeWidgetConfig> = {
  things_to_do: {
    component: HomeThingsToDo,
    titleKey: "tasks:things_to_do",
    isAvailable: () => true,
  },
  notifications: {
    component: HomeNotifications,
    titleKey: "common:notifications",
    isAvailable: () => true,
  },
  my_company: {
    component: HomeMyCompany,
    titleKey: "core:home_widget_my_company",
    isAvailable: () => true,
  },
  news: {
    component: HomeNews,
    titleKey: "core:news",
    isAvailable: (ctx) => ctx.isFeatureEnabled(ApiFeatureType.blog),
  },
  jobs: {
    component: HomeJobs,
    titleKey: "ats:my_active_jobs",
    isAvailable: (ctx) => ctx.canIEdit(ApiPermission.recruiting_module),
  },
  upcoming_events: {
    component: HomeUpcomingEvents,
    titleKey: "calendar:upcoming",
    isAvailable: (ctx) => ctx.canIEdit(ApiPermission.see_employee_directory),
  },
  my_team: {
    component: HomeMyTeam,
    titleKey: "common:my_team",
    isAvailable: (ctx) => ctx.canIEdit(ApiPermission.see_employee_directory),
  },
  upcoming_birthdays: {
    component: HomeUpcomingBirthdays,
    titleKey: "core:upcoming_birthdays",
    isAvailable: (ctx) =>
      ctx.canIEdit(ApiPermission.see_employee_directory) &&
      ctx.isFeatureEnabled(ApiFeatureType.core_company_calendar),
  },
};

export const isHomeWidgetAvailable = (id: HomeWidgetId, ctx: HomeWidgetContext): boolean =>
  homeWidgetRegistry[id]?.isAvailable(ctx) ?? false;

export const homeWidgetDefaultOrder: HomeWidgetId[] = [
  "things_to_do",
  "notifications",
  "my_company",
  "news",
  "jobs",
  "upcoming_events",
  "my_team",
  "upcoming_birthdays",
];
